<template>
    <div>

        <vue-headful title="Role Request :: MeritEHS" />

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light"><i class="fa fa-cogs"></i> Admin</li>
                <li class="breadcrumb-item active"> Role Requests</li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-xl-10 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header"><strong>Pending Requests <span>({{ requests.length }})</span></strong></div>
                        <div class="card-body">
                            <div class="form-inline">
                                <label class="mr-1">User:</label>
                                <b-form-select v-model="filter_by_user_id" :options="filterUsers" size="sm" @change="filterRequests"></b-form-select>
                                <b-button variant="light" size="sm" v-on:click="filter_by_user_id = null" class="ml-1" v-if="filter_by_user_id">
                                    <i class="fa fa-remove"></i> Clear
                                </b-button>
                            </div>
                            <hr/>

                            <div class="alert alert-danger mt-2 mb-2" v-if="errors.request_billing_error">
                                <h4 class="text-danger">User Licenses Exceeded</h4>
                                <div class="mb-1" v-for="error in errors.request_billing_error">{{ error }}</div>
                                <p>To upgrade your user licenses, an admin can visit the <router-link to="/billing">Account Billing Settings</router-link></p>
                            </div>

                            <b-table striped hover bordered small :items="filteredRequests" :fields="requestFields" show-empty>
                                <template v-slot:cell(id)="data">
                                    <b-button variant="success" size="xs" v-on:click="takeAction(data.item.id, 'Approve')">
                                        <i class="fa fa-check"></i> Approve
                                    </b-button>
                                    <b-button variant="danger" size="xs" v-on:click="takeAction(data.item.id, 'Deny')">
                                        <i class="fa fa-remove"></i> Deny
                                    </b-button>
                                </template>
                                <template v-slot:cell(FirstName)="data">
                                    {{ data.item.FirstName }} {{ data.item.LastName }}
                                </template>
                                <template slot="empty" slot-scope="scope">
                                    <h4>{{ scope.emptyText }}</h4>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                errors: {},
                requests: [],
                requestFields: [
                    {key: 'id', label: 'Actions'},
                    {key: 'name', label: 'Role'},
                    {key: 'FirstName', label: 'User'},
                ],
                users: [],
                filter_by_user_id: null,
            }
        },

        computed: {
            filterUsers(){
                //Setup
                var users = [
                    {value: null, text: 'Select a User to filter Requests'}
                ];

                //Loop
                for(var user_id in this.users)
                {
                    //Append
                    users.push({value: this.users[user_id].user_id, text: this.users[user_id].name})
                }

                return users;
            },

            filteredRequests(){
                //Check for null
                if(!this.filter_by_user_id)
                {
                    return this.requests;
                }

                //Loop and build
                var requests = [];

                //Loop
                for(var i in this.requests)
                {
                    //Check matching ID
                    if(this.requests[i].requester_id == this.filter_by_user_id)
                    {
                        requests.push(this.requests[i]);
                    }
                }

                //Send it
                return requests;
            },
        },

        methods: {
            //Get the Various Resources We Need to Edit an User
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },

            getRequests: function() {
                //Get the data
                this.$http
                    .get('admin/role-requests')
                    .then(response => {
                        //Set all the data
                        this.requests = response.data.requests;
                        this.users = response.data.users;

                        //Set loading
                        this.loading = false;

                        //Check the route
                        if(this.$route.query.user_id && this.users[this.$route.query.user_id])
                        {
                            this.filter_by_user_id = this.$route.query.user_id;
                        }
                    })
                    .catch(response => {

                    });
            },

            takeAction: function(id, action) {
                //Basic Confirmation Right now
                if(!confirm('Are you sure you want to '+action+' this request?'))
                {
                    return;
                }

                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/role-requests/'+id, {action: action})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Role '+action);

                    //Splice it from the list?
                    this.updateRequests(id);

                    //Return to main list?
                    //this.$router.push('/');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            updateRequests(id, deleteMode = true){
                //We need to check to see if the bid is new, or updated
                for (var i = this.requests.length - 1; i >= 0; i--)
                {
                    //If the IDs match, replace it
                    if(this.requests[i].id == id)
                    {
                        //Check if we are deleting it
                        if(typeof deleteMode != 'undefined' && deleteMode == true)
                        {
                            this.requests.splice(i, 1);
                            return;
                        }

                        //Set the value
                        this.requests.splice(i, 1, action);
                        //this.$refs.correctiveActionModal.hideModal();

                        //Stop here;
                        return;
                    }
                }
            },

            filterRequests(user_id){
                //set it
                this.filter_by_user_id = user_id;
            }
        },

        mounted() {
            //Get the incidents
            this.getRequests();
        }
    }
</script>
